import { gql } from 'graphql-request'

export const GET_USER_TASK_SPECTATOR_FIRST = gql`
  query GET_USER_TASK_SPECTATOR_FIRST(
    $id: Int
    $userId: Int
    $userTaskSpectatorDefaultId: Int
    $userTaskSpectatorType: UserTaskSpectatorType
    $userTaskBonusType: UserTaskBonusType
    $itemPackageId: Int
    $typeFilterDateTask: TypeFilter
    $dateTaskInitial: String
    $dateTaskFinal: String
    $typeFilterQuantityTask: TypeFilter
    $quantityTaskInitial: Float
    $quantityTaskFinal: Float
    $typeFilterQuantityCompleted: TypeFilter
    $quantityCompletedInitial: Float
    $quantityCompletedFinal: Float
    $completed: Boolean
    $rescued: Boolean
    $typeFilterDateRescued: TypeFilter
    $dateRescuedInitial: String
    $dateRescuedFinal: String
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getUserTaskSpectatorFirst(
      id: $id
      userId: $userId
      userTaskSpectatorDefaultId: $userTaskSpectatorDefaultId
      userTaskSpectatorType: $userTaskSpectatorType
      userTaskBonusType: $userTaskBonusType
      itemPackageId: $itemPackageId
      typeFilterDateTask: $typeFilterDateTask
      dateTaskInitial: $dateTaskInitial
      dateTaskFinal: $dateTaskFinal
      typeFilterQuantityTask: $typeFilterQuantityTask
      quantityTaskInitial: $quantityTaskInitial
      quantityTaskFinal: $quantityTaskFinal
      typeFilterQuantityCompleted: $typeFilterQuantityCompleted
      quantityCompletedInitial: $quantityCompletedInitial
      quantityCompletedFinal: $quantityCompletedFinal
      completed: $completed
      rescued: $rescued
      typeFilterDateRescued: $typeFilterDateRescued
      dateRescuedInitial: $dateRescuedInitial
      dateRescuedFinal: $dateRescuedFinal
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        id
        userId
        user {
          id
          username
        }
        userTaskSpectatorDefaultId
        userTaskSpectatorDefault {
          id
          name
          value
        }
        userTaskSpectatorType
        userTaskBonusType
        itemPackageId
        iconUserTaskSpectator
        dateTask
        quantityTask
        quantityCompleted
        completed
        rescued
        dateRescued
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_USERS_TASKS_SPECTATORS = gql`
  query GET_USERS_TASKS_SPECTATORS(
    $take: Int
    $skip: Int
    $userId: Int
    $userTaskSpectatorDefaultId: Int
    $userTaskSpectatorType: UserTaskSpectatorType
    $userTaskBonusType: UserTaskBonusType
    $itemPackageId: Int
    $typeFilterDateTask: TypeFilter
    $dateTaskInitial: String
    $dateTaskFinal: String
    $typeFilterQuantityTask: TypeFilter
    $quantityTaskInitial: Float
    $quantityTaskFinal: Float
    $typeFilterQuantityCompleted: TypeFilter
    $quantityCompletedInitial: Float
    $quantityCompletedFinal: Float
    $completed: Boolean
    $rescued: Boolean
    $typeFilterDateRescued: TypeFilter
    $dateRescuedInitial: String
    $dateRescuedFinal: String
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getUsersTasksSpectators(
      take: $take
      skip: $skip
      userId: $userId
      userTaskSpectatorDefaultId: $userTaskSpectatorDefaultId
      userTaskSpectatorType: $userTaskSpectatorType
      userTaskBonusType: $userTaskBonusType
      itemPackageId: $itemPackageId
      typeFilterDateTask: $typeFilterDateTask
      dateTaskInitial: $dateTaskInitial
      dateTaskFinal: $dateTaskFinal
      typeFilterQuantityTask: $typeFilterQuantityTask
      quantityTaskInitial: $quantityTaskInitial
      quantityTaskFinal: $quantityTaskFinal
      typeFilterQuantityCompleted: $typeFilterQuantityCompleted
      quantityCompletedInitial: $quantityCompletedInitial
      quantityCompletedFinal: $quantityCompletedFinal
      completed: $completed
      rescued: $rescued
      typeFilterDateRescued: $typeFilterDateRescued
      dateRescuedInitial: $dateRescuedInitial
      dateRescuedFinal: $dateRescuedFinal
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        userId
        user {
          id
          username
        }
        userTaskSpectatorDefaultId
        userTaskSpectatorDefault {
          id
          name
          value
        }
        userTaskSpectatorType
        userTaskBonusType
        itemPackageId
        iconUserTaskSpectator
        dateTask
        quantityTask
        quantityCompleted
        completed
        rescued
        dateRescued
        createdAt
        updatedAt
      }
    }
  }
`
